import React from "react";

const dataInputSmp = {
    title: `Input APK SMP/MTs/Pake B > Rekap Data Jumlah Penduduk Usia 13 - 15 Tahun dengan Jumlah Siswa SMP/MTs/Paket B`,
    data: [],
    columns: [
        {
            Header: 'No',
            rowSpan: 2,
            columns: [
                {
                    Header: 'NO',
                    skip:1,
                    Cell:({row}) => {
                        const { index } = row;
                        return index + 1;
                    },
                },
            ]
        },
        {
            // Header: 'Kecamatan',
            Header: () => {
                const kode_wilayah = localStorage.getItem('kode_wilayah_aplikasi');
                return(
                    kode_wilayah === '040000' ? "Kab/Kota" : "Kecamatan"
                )
            },
            id: 'kecamatan',
            rowSpan: 2,
            columns: [
                {
                    Header: '',
                    skip: 1,
                    accessor: 'kecamatan',
                    Cell: ({ row }) => (
                        <div style={{ textAlign: "left" }}>
                            {row.original.kecamatan}
                        </div>
                    )
                },
            ]
        },
        {
            Header: 'Jumlah Penduduk Umur 13-15',
            align: 'center',
            columns: [
                {
                    Header: 'L',
                    accessor: 'penduduk_13_15_l',
                    type: 'input',
                    align: 'center',
                },
                {
                    Header: 'P',
                    accessor: 'penduduk_13_15_p',
                    type: 'input',
                    align: 'center',
                },
                {
                    id: 'jml_ppd',
                    Header: 'Jumlah',
                    align: 'center',
                    Cell: ({ row }) => {
                        const { penduduk_13_15_l, penduduk_13_15_p } = row.original;

                        const value = parseInt(penduduk_13_15_l || 0) + parseInt(penduduk_13_15_p || 0);

                        return (<span>{ value }</span>)
                    }
                },
            ]
        },
        {
            Header: 'Jumlah Seluruh SMP',
            align: 'center',
            columns: [
                {
                    Header: 'L',
                    accessor: 'murid_l_6',
                    type: 'input',
                    align: 'center',
                },
                {
                    Header: 'P',
                    accessor: 'murid_p_6',
                    type: 'input',
                    align: 'center',
                },
                {
                    id: 'jumlah_6',
                    Header: 'Jumlah',
                    align: 'center',
                    Cell: ({ row }) => {
                        const { murid_l_6, murid_p_6 } = row.original;
                        const value = parseInt(murid_l_6 || 0) + parseInt(murid_p_6 || 0);

                        return (<span>{ value }</span>)
                    }
                },
            ]
        },
        {
            Header: 'Jumlah Seluruh MTs',
            align: 'center',
            columns: [
                {
                    Header: 'L',
                    accessor: 'murid_l_10',
                    type: 'input',
                    align: 'center',
                },
                {
                    Header: 'P',
                    accessor: 'murid_p_10',
                    type: 'input',
                    align: 'center',
                },
                {
                    id: 'jumlah_10',
                    Header: 'Jumlah',
                    align: 'center',
                    Cell: ({ row }) => {
                        const { murid_l_10, murid_p_10 } = row.original;
                        const value = parseInt(murid_l_10 || 0) + parseInt(murid_p_10 || 0);

                        return (<span>{ value }</span>)
                    }
                },
            ]
        },
        {
            Header: 'Jumlah Seluruh Paket B',
            align: 'center',
            columns: [
                {
                    Header: 'L',
                    accessor: 'murid_l_12',
                    type: 'input',
                    align: 'center',
                },
                {
                    Header: 'P',
                    accessor: 'murid_p_12',
                    type: 'input',
                    align: 'center',
                },
                {
                    id: 'jumlah_12',
                    Header: 'Jumlah',
                    align: 'center',
                    Cell: ({ row }) => {
                        const { murid_l_12, murid_p_12 } = row.original;
                        const value = parseInt(murid_l_12 || 0) + parseInt(murid_p_12 || 0);

                        return (<span>{ value }</span>)
                    }
                }
            ]
        },
        {
            Header: 'Jumlah',
            align: 'center',
            columns: [
                {
                    id: 'jumlah_siswa_l_total',
                    Header: 'L',
                    align: 'center',
                    Cell: ({ row }) => {
                        const { murid_l_6, murid_l_10, murid_l_12 } = row.original;
        
                        const value = parseInt(murid_l_6 || 0) + parseInt(murid_l_10 || 0) + parseInt(murid_l_12 || 0);
        
                        return (<span>{ value }</span>)
                    }
                },
                {
                    id: 'jumlah_siswa_p_total',
                    Header: 'P',
                    align: 'center',
                    Cell: ({ row }) => {
                        const { murid_p_6, murid_p_10, murid_p_12 } = row.original;
        
                        const value = parseInt(murid_p_6 || 0) + parseInt(murid_p_10 || 0) + parseInt(murid_p_12 || 0);
        
                        return (<span>{ value }</span>)
                    }
                },
                {
                    id: 'jumlah_siswa_total',
                    Header: 'Jumlah',
                    align: 'center',
                    Cell: ({ row }) => {
                        const { murid_p_6, murid_l_6, murid_p_10, murid_l_10, murid_l_12, murid_p_12 } = row.original;
        
                        const value = parseInt(murid_p_6 || 0) + parseInt(murid_p_10 || 0) + parseInt(murid_l_6 || 0) + parseInt(murid_l_10 || 0) + parseInt(murid_l_12 || 0) + parseInt(murid_p_12 || 0);
        
                        return (<span>{ value }</span>)
                    }
                },
            ]
        }
    ]
}

export default dataInputSmp;